import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';
import { RegistroComponent } from '../registro/registro.component';
import { ValidarPassword } from 'src/app/utilidades/utilidades';

@Component({
  	selector: 'app-cambio-contrasena',
  	templateUrl: './cambio-contrasena.component.html',
  	styleUrls: ['./cambio-contrasena.component.css']
})
export class CambioContrasenaComponent implements OnInit {


	newCuenta:any = {
		password:"",
		confirmar:"",
		uuid:""
	};

  	constructor( 
  		private newFuncionService:FuncionService, 
  		private newRouter:Router, 
  		private newActivatedRoute:ActivatedRoute,
      private newTitle: Title
  	 ) {}

  	ngOnInit(): void {
      this.newTitle.setTitle("Cambio de contraseña");
      this.newActivatedRoute.paramMap.subscribe( (newRouterParams:any) => {
        this.newFuncionService.fnValidarSolicitud({solicitud:{uuid:newRouterParams.params.uuid}}).subscribe( (response:any) =>{
                if( !response.success ){
            this.newFuncionService.setNewAlerta( environment.alerta.cambio.expired );
                    this.newRouter.navigate(["recuperacion"]);
          }
        });
      });
  		this.newActivatedRoute.paramMap.subscribe( (response:any) => {
  			this.newCuenta.uuid = response.params.uuid;
		  }).unsubscribe();
  	}
       
  	fnVerificarClaves(){
  		if( this.newCuenta.password === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.cambio.password );
  		}else if( this.newCuenta.confirmar === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.cambio.confirmar );
  		}else if( this.newCuenta.confirmar !== this.newCuenta.password ){
  			this.newFuncionService.setNewAlerta( environment.alerta.cambio.iguales );
  		}else if(!ValidarPassword(this.newCuenta.password)){
			this.newFuncionService.setNewAlerta(environment.alerta.cambio.validarContraseña)
		}
		else{
  			this.newFuncionService.setNewMensaje("Actualizando la contraseña de tu cuenta...");
            this.newFuncionService.fnCambiarContrasena( this.newCuenta )
			.subscribe(( response:any ) => {
                this.newFuncionService.setNewMensaje(null);
				if( response.success ){
                    this.newFuncionService.setNewAlerta( environment.alerta.cambio.success );
                    this.newRouter.navigate(["acceso"]);
                }else{
                    this.newFuncionService.setNewAlerta( environment.alerta.cambio.expired );
                    this.newRouter.navigate(["recuperacion"]);
                }
			});
  		}

  	}

}
